import React, { useRef, useState } from 'react';
import { Empty, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate, faFileImport, faPlus, faRotate, faSquare, faTrashAlt, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { ControleLateral } from './styled';
import { ContainerPontosAnalise } from './styled';

//APP
import { GeoPointFeature } from '../..';
import { LabAnaliseItens } from '../../../../../../../../../../../../../../../../services/LabAnalise';
import { calcularPorcentagem } from '../../../../../../meta';
import { errorAlert, warningAlert } from '../../../../../../../../../../../../../../../../utils/alert';
import { casarComMalha, lerSelecaoDoArquivo } from '../../meta/importarSelecao';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../Components/ButtonCustom';
import { Box } from '../../../../../../../../../../../../../../../../Components/CustomUi/box';
import { Render } from '../../../../../../../../../../../../../../../../Components/CustomUi/render';
import { Select } from '../../../../../../../../../../../../../../../../Components/CustomUi/Select';
import { LineDivider } from '../../../../../../../../../../../../../../../../Components/CustomUi/LineDivider';
import { PontosAdicionados } from '../pontosAdicionados';
import { Inline } from '../../../../../../../../../../../../../../../../Components/CustomUi/inline';
import { SelecaoEmMassa } from '../selecaoEmMassa';
import { AncoraSelecaoEmMassa } from '../selecaoEmMassa/styled';
import { leadZero } from '../../../../../../../../../../../../../../../../utils';


interface PropsControle {
    /** Usado apenas para desabilitar as ações de seleção enquanto se insere pontos. */
    inserirPontos: boolean
    pontos?: GeoPointFeature[] | any
    pontos_totais: number
    talhao_area: string
    tipo_analise_selecionada: string
    setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>
    setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>
    cor_selecionada: string
    setCor_selecionada: React.Dispatch<React.SetStateAction<string>>
    selecionarTodos: boolean
    grupoAnalises: LabAnaliseItens[]
    pontos_selecionados_adicionados: any[]
    fake_loading: boolean
    adicionarPontosSelecionados: Function
    selecionarTodosPontos: Function
    limparPontosSelecionados: Function
    deletarPontosSelecionados: Function
    grupoAnalisesTratado: any[]
    isFullscreen?: boolean
    /** Todos os pontos da malha do talhão (base da seleção em massa). */
    pontos_da_malha?: GeoPointFeature[]
    /** Análises já salvas no formulário, usadas só para leitura na seleção em massa. */
    analises_salvas?: any[]
    selecionarPontosEmMassa: (pontos: GeoPointFeature[]) => void
    /** Inverte a seleção: marcados saem, desmarcados entram. */
    inverterSelecaoPontos: () => void
}

export const ControleLateralModal: React.FC<PropsControle> = ({ inserirPontos, tipo_analise_selecionada,
    setTipo_analise_selecionada, setTipo_analise_selecionada_id, cor_selecionada, setCor_selecionada,
    selecionarTodos, pontos_totais, talhao_area, pontos, pontos_selecionados_adicionados, fake_loading,
    adicionarPontosSelecionados, selecionarTodosPontos, limparPontosSelecionados, deletarPontosSelecionados,
    grupoAnalisesTratado, isFullscreen = false, pontos_da_malha = [], analises_salvas = [],
    selecionarPontosEmMassa, inverterSelecaoPontos
}) => {

    const [openSelecionar, setOpenSelecionar] = useState<boolean>(false)
    const [open_massa, setOpen_massa] = useState<boolean>(false)
    const [ancora_massa, setAncora_massa] = useState<DOMRect | null>(null)
    const btn_massa_ref = useRef<HTMLButtonElement | null>(null)
    const [importando, setImportando] = useState<boolean>(false)
    const input_arquivo_ref = useRef<HTMLInputElement | null>(null)

    function abrirSelecaoEmMassa() {
        if (!tipo_analise_selecionada) {
            return warningAlert('Selecione uma análise antes de selecionar os pontos.', undefined, undefined, 'select-analysis-mass')
        }
        setAncora_massa(btn_massa_ref.current?.getBoundingClientRect() ?? null)
        setOpen_massa(true)
    }

    function confirmarSelecaoEmMassa(pontos: GeoPointFeature[]) {
        selecionarPontosEmMassa(pontos)
        setOpen_massa(false)
    }

    function abrirSeletorArquivo() {
        if (!tipo_analise_selecionada) {
            return warningAlert('Selecione uma análise antes de importar os pontos.', undefined, undefined, 'select-analysis-import')
        }
        input_arquivo_ref.current?.click()
    }

    /**
     * Lê o KML/Shape escolhido e transforma seu conteúdo na seleção atual.
     *
     * O arquivo carrega apenas os NOMEs dos pontos, então quem manda na posição é
     * sempre a malha em tela — importar seleciona pontos existentes, nunca cria.
     */
    async function aoEscolherArquivo(evento: React.ChangeEvent<HTMLInputElement>) {
        const arquivo = evento.target.files?.[0]

        // Permite reimportar o mesmo arquivo: sem isso o onChange não dispara de novo.
        evento.target.value = ''

        if (!arquivo) return

        setImportando(true)
        try {
            const { nomes, total } = await lerSelecaoDoArquivo(arquivo)

            if (total === 0) {
                return warningAlert('Nenhum ponto encontrado no arquivo.', undefined, undefined, 'import-empty')
            }

            const { encontrados, ignorados } = casarComMalha(nomes, pontos_da_malha)

            if (encontrados.length === 0) {
                return warningAlert('Nenhum ponto do arquivo corresponde à malha deste talhão.', undefined, undefined, 'import-no-match')
            }

            selecionarPontosEmMassa(encontrados)

            if (ignorados.length > 0) {
                warningAlert(
                    `${encontrados.length} ponto(s) selecionado(s). ${ignorados.length} ponto(s) do arquivo não existem nesta malha e foram ignorados.`,
                    undefined, undefined, 'import-partial'
                )
            }
        } catch {
            errorAlert('Não foi possível ler o arquivo. Envie o .kml ou o .zip do shape baixado da análise.')
        } finally {
            setImportando(false)
        }
    }

    function selectCor(cod) {
        setTipo_analise_selecionada_id(cod)
        const filter = grupoAnalisesTratado?.filter((item) => item?.cod_analise === cod)
        setCor_selecionada(filter[0]?.cor)
    }

    const Wrapper = isFullscreen ? React.Fragment : ControleLateral

    return (
        <Wrapper>
            <Box style={{ flexShrink: 0 }}>
                <label
                    style={{ fontSize: '12px', fontWeight: 700, color: '#7b7b7b', margin: 0, padding: 0 }}
                >
                    Pontos ({pontos?.length})
                </label>

                <Inline>
                    <Select
                        label='Profundidade | Análises'
                        placeholder='Selecione a análise'
                        icon={faSquare}
                        value={tipo_analise_selecionada}
                        onChange={setTipo_analise_selecionada}
                        onChangeID={(e) => selectCor(e)}
                        onChangeExtra={setCor_selecionada}
                        open={openSelecionar}
                        trigger={setOpenSelecionar}
                        items={grupoAnalisesTratado}
                        descricaoItem={'analise_profundidade_nome'}
                        idItem={'cod_analise'}
                        cor={cor_selecionada}
                        extraItem={'cor'}
                    />
                    <Tooltip title="Importar seleção de KML/Shape"><samp>
                        <ButtonCustom
                            type='tertiary'
                            onClick={abrirSeletorArquivo}
                            icon={<FontAwesomeIcon icon={faFileImport} />}
                            disabled={inserirPontos || tipo_analise_selecionada == ''}
                            loading={importando}
                            style={{ justifyContent: 'center', marginTop: 25 }}
                        /></samp>
                    </Tooltip>
                </Inline>

                <AncoraSelecaoEmMassa>
                    <Inline gap={8}>

                        <Tooltip title="Inverter seleção"><samp>
                            <ButtonCustom
                                type='primary'
                                onClick={() => inverterSelecaoPontos()}
                                icon={<FontAwesomeIcon icon={faRotate} />}
                                disabled={inserirPontos || pontos?.length <= 0}
                                style={{ justifyContent: 'center' }}
                                title='Inverter seleção'
                            /></samp>
                        </Tooltip>
                        <ButtonCustom
                            type='secondary'
                            onClick={abrirSelecaoEmMassa}
                            refProp={btn_massa_ref}
                            icon={<FontAwesomeIcon icon={faWandMagicSparkles} />}
                            disabled={inserirPontos}
                            style={{ flex: 1, justifyContent: 'center' }}
                        >
                            Seleção em massa
                        </ButtonCustom>
                        <Tooltip title="Limpar seleção"><samp>
                            <ButtonCustom
                                type='secondary'
                                danger
                                onClick={() => limparPontosSelecionados()}
                                icon={<FontAwesomeIcon icon={faTrashAlt} />}
                                disabled={inserirPontos || pontos?.length <= 0}
                                style={{ justifyContent: 'center' }}
                            /></samp>
                        </Tooltip>

                        {/* input nativo escondido: o ButtonCustom acima é o gatilho visual. */}
                        <input
                            ref={input_arquivo_ref}
                            type='file'
                            accept='.kml,.zip,.shp'
                            style={{ display: 'none' }}
                            onChange={aoEscolherArquivo}
                        />
                    </Inline>

                    <SelecaoEmMassa
                        open={open_massa}
                        onClose={() => setOpen_massa(false)}
                        ancora={ancora_massa}
                        isFullscreen={isFullscreen}
                        pontos_da_malha={pontos_da_malha}
                        pontos_selecionados_adicionados={pontos_selecionados_adicionados}
                        analises_salvas={analises_salvas}
                        talhao_area={talhao_area}
                        onConfirmar={confirmarSelecaoEmMassa}
                    />
                </AncoraSelecaoEmMassa>

                <LineDivider />

                <ContainerPontosAnalise>
                    <h3 className='points-title'>Pontos selecionados</h3>
                    <Render condition={pontos?.length > 0}>
                        <div className='points-grid'>
                            {pontos?.map((point, index) => (
                                <div
                                    key={index}
                                    className='point-card'
                                    style={{ '--cor-do-item': point?.COR, } as React.CSSProperties}
                                >
                                    {leadZero(point?.NOME)}{' '}
                                </div>
                            ))}
                        </div>
                    </Render>

                    <Render condition={pontos?.length <= 0}>
                        <Empty
                            style={{
                                display: 'flex',
                                fontSize: '12px',
                                height: '30px',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                gap: 3,
                                padding: 0,
                                margin: 0,
                            }}
                            imageStyle={{ width: '30px', height: '30px', padding: 0, margin: 0 }}
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<p style={{ margin: 0, padding: 0 }}> Nenhum ponto selecionado!</p>}
                        />
                    </Render>
                    <div className='infos__pontos__selecionados'>
                        <div>
                            <label>Pontos</label>
                            <strong>{`${pontos?.length} de ${pontos_totais} ${calcularPorcentagem(
                                pontos?.length,
                                pontos_totais
                            )}`}</strong>
                        </div>
                        <div>
                            <label>Grid amostral</label>
                            <strong>
                                {pontos.length > 0 ? (Number(talhao_area) / pontos.length).toFixed(2) : 0}{' '}
                            </strong>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ButtonCustom
                            type='secondary'
                            onClick={adicionarPontosSelecionados}
                            icon={<FontAwesomeIcon icon={faPlus} />}
                        >
                            Adicionar análise
                        </ButtonCustom>
                    </div>
                </ContainerPontosAnalise>
            </Box>
            {/* Sempre visível: vazio, orienta o usuário a adicionar a primeira análise. */}
            <Box style={{ flexShrink: 0 }} gap={5}>
                <h3 style={{ color: '#757575', fontSize: '12px', fontWeight: 700, margin: 0, padding: 0 }}>
                    Pontos adicionados
                </h3>

                <Render condition={pontos_selecionados_adicionados?.length > 0}>
                    <PontosAdicionados
                        pontos_selecionados_adicionados={pontos_selecionados_adicionados}
                        deletarPontosSelecionados={deletarPontosSelecionados}
                        fake_loading={fake_loading}
                    />
                </Render>

                <Render condition={!(pontos_selecionados_adicionados?.length > 0)}>
                    {/* Sem `height` fixa: a mensagem tem duas linhas em larguras estreitas. */}
                    <Empty
                        style={{
                            display: 'flex',
                            fontSize: '12px',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            gap: 8,
                            padding: 0,
                            margin: 0,
                        }}
                        imageStyle={{ width: '30px', height: '30px', padding: 0, margin: 0, flexShrink: 0 }}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <p style={{ margin: 0, padding: 0, textAlign: 'left' }}>
                                Nenhuma análise adicionada! Selecione os pontos e clique em{' '}
                                <strong>Adicionar análise</strong>.
                            </p>
                        }
                    />
                </Render>
            </Box>
        </Wrapper>
    )
}
